export default __webpack_public_path__ + "static/media/graded.60764b5c.svg";